import Operational from "./operational";
import {observable, autorun, computed, untracked} from "../mobx/mobx-2.6.2.umd";
import {doEventHandler} from "./createPageConfig";
import {isObject} from "./util";

/**
 * 	生命周期：
 * 		创建: constructor -> willBuildState --> buildState --> didBuildState
 * 		更新：当willBuildState, buildState, didBuildState依赖的可观察对象变化时, 
 * 依次调用willBuildState, buildState, didBuildState 
 * 		释放: destroy
 * 		 
 */

var LIST_CHILDREN_POSTFIX = "].$children";

var META = {};

export default class Component extends Operational{
	constructor(page, id, props, context){
		super();
		this.id = id;
		this.props = props;
		
		this.context = context || {parentPath: "", vars : {props: {}, params: page.params || {}, $page: page}};
		this.page = page;
		this.initOperation();
		this._initEvent();
		this.parentPathOB = observable(this.context.parentPath || "");
		
	        this.compid = computed(() => {
	            var parentPath = this.getParentPath();
	            return parentPath ? (parentPath + "." + this.id) : this.id; 
	        });

	        this.statePath = computed(() => {
	            var parent = this.parentPathOB.get();
	            return parent ? (parent + "." + this.id) : this.id; 
	        });

	        this.oldCompid = null;
        
        
	        this.page.$addComp(this.getCompid(), this);
        
	        this.constructed(); //支持data动态创建, 保持组件new完后就能用
        
	}
	
	constructed(){
		if (!this.hasDependence()){
        		this.inited();
        	}else{
        		this.page.compPromise(this.props.id); //强制创建promise对象
        	}
        	this._update(this.context);
	}
	
	//只支持path以.value结尾的
	getDataByContext(path){
		let ret = this.context.vars ||[];
		let items = path.split(".");
		if (items[items.length-1] === "value"){
			for (let i=0; i<items.length-1; i++){
				ret = ret[items[i]];
				if (!ret){
					break;
				}
			}
		}
		return ret;
	}
	
	getDataIdByContext(path){
		var comp = this.getDataByContext(path);
		if (comp) return comp.id;
	}
	
	//表示组件是否依赖别的组件
	hasDependence(){
		return false;
	}
	
	//不是直接的父组件, 是指逻辑的父节点，一般是list
	getParentComp(){
	    var ret = null;
	    var path = this.getParentPath();
	    if (path){
	    	var index = path.lastIndexOf("[");
	    	if (index != -1){
	    		path = path.substr(0, index);
	    		ret = this.page.comp(path);
	    	}
	    }
	    return ret;
	}	
	
	getParentPath(){
        	var result = this.parentPathOB.get();
	        result = result.replace(new RegExp("\\.items\\["), '[');
        	result = result.replace(new RegExp("\\.\\$children"), '');
	        return result;
	}
	
	inited(){
		this.page.resolvedComp(this.getCompid());
	}

	//TODO 当前仅支持同一层次内的组件依赖，如果需要支持里层依赖外层的组件，编译时需要记录信息
	compPromise(id){
		var parentPath = this.getParentPath();
		var compid = parentPath ? (parentPath.id + "." + id) : id;
		return this.page.compPromise(compid);
	}
	
	
	fireEvent(name, evt) {// 重新实现，增加bindingContext
		if (!evt.hasOwnProperty("context")){
			evt.context = Object.assign({}, this.context.vars || {});
		}
		return super.fireEvent(name, evt);
	}

	_prepareEventHandler(handler){
		if (handler){
			var vars = this.context ? (this.context.vars || {}) : {};
			var items = handler.split(".");
			for (var i=0; i<items.length; i++){
				if (items[i] && (items[i+1] === "$children")){
					var val = vars["$$" + items[i] + "$$"];
					if (val){
						items[i] = this._prepareEventHandler(val);
					}
				}
			}
			return items.join(".");
		}else{
			return handler;
		}
	}
	
	_initEvent(){
		var events = this.props.$events || {};
		for (let name in events){
			if (events.hasOwnProperty(name)){
				if (events[name]){
					this.on(name, (evt) => {
						let handler = this.props.$events[name]; 
						var items = handler.split(",");
						for (var i=0; i<items.length; i++){
							var item = items[i];
							if (item && item.indexOf("{{")>-1 && item.indexOf("}}")>-1){
								var compPath = item.split(":")[0].replace("{{", "").replace("}}", "");
								compPath = this._prepareEventHandler(compPath);
								var methodName = item.split(":")[1];
								items[i] = "{{" + compPath + "}}:" + methodName;
							}
						}
						handler = items.join(",");
						
						//TODO handler有多个时，表示是reactjs事件转为自定义事件的情况
						return doEventHandler(this.page, this, handler, evt, handler.split(",").length>1);
					});
				}
			}
		}
	}
	
	defineMeta(meta){
		if (!meta) return;
		Object.assign(META, meta);
	}
	
	processNativeEvent(evt, tagName, eventName){
		if (!eventName || !evt || !evt.data || !tagName) return;
		if (META && META[tagName] && META[tagName]
			&& META[tagName].events && META[tagName].events[eventName] 
			&& META[tagName].events[eventName].data){
			var data = {};
			var names = META[tagName].events[eventName].data;
			var nativeEvent = null;
			for (var i=0; i<names.length; i++){
				data[names[i]] = evt.data[i];
				if (evt.data[i] && evt.data[i].stopPropagation){
					data.originalEvent = evt.data[i];
					nativeEvent = evt.data[i];
				}
			}
			evt.data = data;
			evt.nativeEvent = nativeEvent;
		}else{
			var data = {};
			var index = 1;
			var nativeEvent = null;
			for (var i=0; i<evt.data.length; i++){
				if (evt.data[i] && evt.data[i].stopPropagation){
					data.originalEvent = evt.data[i];
					nativeEvent = evt.data[i];
				}else{
					data["param" + i] = evt.data[i];
					i++;
				}
			}
			evt.data = data;
			evt.nativeEvent = nativeEvent;
		}
	}
	
	willBuildState(context){}
	
	//子类重写
	buildState(context){
		var state = {compid: this.getCompid()};
		Object.assign(state, this._evalAttr(this.props.$attrBindFns, this.context.vars));
		return state;
	}
	
	_evalAttr(attrs, vars){
		var ret = {};
		if (attrs){
			for (var key in attrs){
				if (typeof this.page[attrs[key]] === "function"){
					var curVars = Object.assign({$page: this.page, $comp: this}, vars);
					ret[key] = this.page[attrs[key]](curVars);
					if (key == "class"){
						ret[key] = this._processClass(ret[key]);
					}
				}
			}
		}
		return ret;
	}
	
	_processClass(obj){
		var ret = "";
		if (obj && isObject(obj)){
			for (var key in obj){
				if (obj[key]){
					ret += " " + key;
				}
			}
		}
		
		return ret;
	}
	
	didBuildState(state, context){}
	
    //子类重写
	destroy(){
		this.clearListeners();
		if (this.updateDispose) this.updateDispose();
        this.page.$removeComp(this.getCompid());
	}
	
	//-------内部api-----------------------
    _update(context){
    	this.context = context;
    	if (this.updateDispose) this.updateDispose();
    	if (context.parentPath) this.parentPath = context.parentPath;
    	this.updateDispose = autorun(() => {
            this.parentPathOB.get(); //当parentPath更新时, 自动触发此方法执行, 从而调用update方法
            this.willBuildState(context);
            var state = this.buildState(context);
			//不要因为ui渲染读取observable 多依赖上不需要的内容
			untracked(()=>{
				this.setState(state);
			});
            this.didBuildState(state, context);
        });
    }

	//------api--------------------------------
    set parentPath(v){
        this.oldCompid = this.getCompid();
        this.parentPathOB.set(v);
    }

    get parentPath(){
        this.parentPathOB.get();
    }

    getCompid(){
        return this.compid.get();
    }

    getStatePath(){
        return this.statePath.get();
    }
    
    getContext(){
    	return this.context;
    }
    
	//必须显示调用此方法，才会将状态同步到微信的data中
	setState(state){
		state = state || {};
		var compid = this.getCompid();
		state.compid = compid;
        
		//同一个组件换位置时, 需要删除原来的组件
        if (this.oldCompid && (this.oldCompid != compid)
        		&& (this === this.page.comp(this.oldCompid))){
            this.page.$removeComp(this.oldCompid);
        }
        this.page.$addComp(this.getCompid(), this);
        
        var options = {};
        options[this.getStatePath()] = state;
        this.page.setData(options);
	}
	//-----------------------------------------
}
